import { css } from '@emotion/css';

const skeletonCard = css`
  padding: var(--dimensions-6);
  border: 1px solid var(--colors-neutral-300);
  border-radius: var(--radius-2);
  display: flex;
  flex-direction: column;
  gap: var(--spacings-3);
  width: 100%;
  height: 191px;
`;

const skeletonHeader = css`
  display: flex;
  justify-content: space-between;

  & > .MuiBox-root {
    display: flex;
    flex-direction: column;
    gap: var(--spacings-0);

    .MuiSkeleton-root:first-of-type {
      width: 100px;
      height: 11px;
    }

    .MuiSkeleton-root:last-of-type {
      width: 183px;
      height: var(--dimensions-6);
    }
  }

  & > .MuiSkeleton-root {
    width: var(--dimensions-6);
    height: var(--dimensions-6);
  }
`;

const dataContainer = css`
  display: flex;

  & > .MuiBox-root {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: var(--spacings-0);

    .MuiSkeleton-root:first-of-type {
      width: 46px;
      height: 15px;
    }

    .MuiSkeleton-root:last-of-type {
      width: var(--dimensions-7);
      height: 15px;
    }
  }
`;

const walletCardSkeletonStyles = {
  skeletonCard,
  skeletonHeader,
  dataContainer,
};

export default walletCardSkeletonStyles;
